/**
 * @generated SignedSource<<4dbf376d49519b322f57d6b693129a21>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type iabCategoryAppConfigQuery$variables = Record<PropertyKey, never>;
export type iabCategoryAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type iabCategoryAppConfigQuery = {
  response: iabCategoryAppConfigQuery$data;
  variables: iabCategoryAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "scmp_iab_category"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"scmp_iab_category\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "iabCategoryAppConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "iabCategoryAppConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "fd8d15bfeecdc1aa584287193ea31412",
    "id": null,
    "metadata": {},
    "name": "iabCategoryAppConfigQuery",
    "operationKind": "query",
    "text": "query iabCategoryAppConfigQuery {\n  appConfig(filter: {entityId: \"scmp_iab_category\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "2d2f08894204be20667bf2145d863b2c";

export default node;
